const EmployeeURL = (employeeId) => `/user/${employeeId}/`;

export default EmployeeURL;
